import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const categories = [{
  id: 1,
  name: 'Single Oils',
  description: 'Pure essential oils from a single plant source',
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop',
  link: '/category/single'
}, {
  id: 2,
  name: 'Blends',
  description: 'Carefully crafted combinations for specific benefits',
  image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop',
  link: '/category/blend'
}, {
  id: 3,
  name: 'Diffusers',
  description: 'Modern devices to disperse essential oils',
  image: 'https://images.unsplash.com/photo-1608571423901-789422f2d6e5?q=80&w=600&auto=format&fit=crop',
  link: '/category/diffuser'
}, {
  id: 4,
  name: 'Wellness',
  description: 'Products designed to enhance your wellbeing',
  image: 'https://images.unsplash.com/photo-1605637465095-0c5327be0c81?q=80&w=600&auto=format&fit=crop',
  link: '/category/wellness'
}];
const riaCategories = [{
  id: 5,
  name: 'Ria Skincare',
  description: 'Seaweed-based facial care for radiant skin',
  image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=600&auto=format&fit=crop',
  link: '/ria-skincare'
}, {
  id: 6,
  name: 'Ria Body Care',
  description: 'Natural formulations for total body wellness',
  image: 'https://images.unsplash.com/photo-1608613304899-ea8098577e38?q=80&w=600&auto=format&fit=crop',
  link: '/ria-skincare'
}, {
  id: 7,
  name: 'Ria Hair Care',
  description: 'Plant-powered solutions for healthy hair',
  image: 'https://images.unsplash.com/photo-1585751119414-ef2636f8aede?q=80&w=600&auto=format&fit=crop',
  link: '/ria-skincare'
}];
const CategorySection = () => {
  const [activeTab, setActiveTab] = useState('essentials');
  const renderCategoryCards = categoryItems => {
    return categoryItems.map(category => <Link key={category.id} to={category.link} className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-86">
        <div className="aspect-[4/3] overflow-hidden" data-id="element-87">
          <img src={category.image} alt={category.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" onError={e => {
          e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
        }} data-id="element-88" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-89"></div>
        </div>
        <div className="p-6 relative" data-id="element-90">
          <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-[#2e7d32] transition-colors duration-300" data-id="element-91">
            {category.name}
          </h3>
          <p className="text-gray-600 text-sm mb-4" data-id="element-92">{category.description}</p>
          <div className="flex items-center text-[#2e7d32] font-medium" data-id="element-93">
            <span data-id="element-94">
              {activeTab === 'essentials' ? 'Explore' : 'Shop Collection'}
            </span>
            <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-95" />
          </div>
        </div>
      </Link>);
  };
  return <section className="py-24 bg-[#f8f9f4]" data-id="element-96">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="text-center mb-10" data-id="element-98">
          <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-99">
            <span data-id="element-100">Discover Our Collections</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-101">
            Explore Our Product Range
          </h2>
          <div className="w-16 h-1 bg-[#2e7d32] mx-auto mt-6 mb-6" data-id="element-102"></div>
          <p className="max-w-2xl mx-auto text-gray-600" data-id="element-103">
            Browse our carefully curated collections of essential oils and
            natural skincare products
          </p>
        </div>
        {/* Category Toggle */}
        <div className="flex justify-center mb-12" data-id="element-104">
          <div className="inline-flex p-1.5 bg-white rounded-full shadow-md" data-id="element-105">
            <button onClick={() => setActiveTab('essentials')} className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeTab === 'essentials' ? 'bg-[#2e7d32] text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-106">
              Essential Oils
            </button>
            <button onClick={() => setActiveTab('ria')} className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeTab === 'ria' ? 'bg-[#2e7d32] text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-107">
              Ria Skincare
            </button>
          </div>
        </div>
        {/* Category Cards Container */}
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12" data-id="element-108">
          {/* Tab Content */}
          <div className={`transition-opacity duration-300 ${activeTab === 'essentials' ? 'opacity-100' : 'opacity-0 hidden'}`} data-id="element-109">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-110">
              {renderCategoryCards(categories)}
            </div>
          </div>
          <div className={`transition-opacity duration-300 ${activeTab === 'ria' ? 'opacity-100' : 'opacity-0 hidden'}`} data-id="element-111">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-112">
              {renderCategoryCards(riaCategories)}
            </div>
          </div>
          {/* View All Link */}
          <div className="mt-12 text-center" data-id="element-113">
            <Link to={activeTab === 'essentials' ? '/products' : '/ria-skincare'} className="inline-flex items-center px-6 py-3 bg-[#f0f7eb] text-[#2e7d32] font-medium rounded-full hover:bg-[#e3f1db] transition-colors duration-300" data-id="element-114">
              View All{' '}
              {activeTab === 'essentials' ? 'Essential Oils' : 'Ria Skincare Products'}
              <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1" data-id="element-115" />
            </Link>
          </div>
        </div>
        {/* Benefits Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-116">
          <div className="bg-white rounded-xl p-8 text-center shadow-md transform transition-transform duration-300 hover:-translate-y-1" data-id="element-117">
            <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-118">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#2e7d32]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-119">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-120" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-121">
              Pure & Natural
            </h3>
            <p className="text-gray-600" data-id="element-122">
              All our products are crafted with 100% natural ingredients,
              ethically sourced from Kenya's rich landscapes.
            </p>
          </div>
          <div className="bg-white rounded-xl p-8 text-center shadow-md transform transition-transform duration-300 hover:-translate-y-1" data-id="element-123">
            <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-124">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#2e7d32]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-125">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-126" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-127">
              Quality Guaranteed
            </h3>
            <p className="text-gray-600" data-id="element-128">
              Every product undergoes rigorous testing to ensure the highest
              quality and effectiveness for our customers.
            </p>
          </div>
          <div className="bg-white rounded-xl p-8 text-center shadow-md transform transition-transform duration-300 hover:-translate-y-1" data-id="element-129">
            <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-130">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#2e7d32]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-131">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" data-id="element-132" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-133">
              Ethically Sourced
            </h3>
            <p className="text-gray-600" data-id="element-134">
              We believe in sustainable practices and fair trade, supporting
              local communities and protecting our environment.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default CategorySection;